import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRight, Loader2, Workflow } from 'lucide-react';
import ChatBubble from './ChatBubble';

const getStepLabel = step => {
  if (!step) return 'Agent steps';
  return step?.tool_name === 'thinking...' ? 'Thinking' : step?.tool_name;
};

const IntermediateStepsPanel = ({ steps = [], isLoading }) => {
  const [open, setOpen] = useState(false);

  if (!steps?.length) return null;

  const stepCount = steps.length;
  const lastStep = steps[stepCount - 1];
  const activeLabel = getStepLabel(lastStep);

  const summaryText = isLoading ? activeLabel : `${stepCount} step${stepCount !== 1 ? 's' : ''}`;

  return (
    <div
      className={`chat-steps-panel ${open ? 'is-open' : 'is-collapsed'} rounded-xl bg-[#f7f6f2] border border-shell-card-border shadow-sm mb-5 overflow-hidden`}>
      <button
        type="button"
        onClick={() => setOpen(prev => !prev)}
        className="flex w-full items-center gap-2.5 px-3 py-2.5 text-left group hover:bg-black/[0.03] transition-colors">
        <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/15">
          <Workflow className="w-4 h-4 text-primary" />
        </div>
        <span className="text-[15px] leading-5 font-medium text-[var(--text-color)] group-hover:text-[var(--text-color)] transition-colors">
          Agent steps
        </span>
        <span className="text-[13px] leading-5 text-muted truncate">{summaryText}</span>
        {isLoading && <Loader2 className="size-4 shrink-0 animate-spin text-primary" />}
        <ChevronRight
          className={`ml-auto size-5 shrink-0 text-muted transition-transform duration-200 ${open ? 'rotate-90' : ''}`}
        />
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="chat-steps-content overflow-hidden">
            <div className="px-3 pb-2.5 pt-1 border-t border-shell-card-border">
              {steps.map((chunk, index) => (
                <ChatBubble key={index} index={index} message={chunk} allMessages={steps} isLoading={isLoading} />
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default IntermediateStepsPanel;
